
import { useCallback, useEffect, useState } from "react";
import CustomModal from "../../core/common/customModal";
import useFetch from "../../hooks/useFetch";
import { API } from "../../common/Constants";
import { getAPIHeaders } from "../../common/Utils";
import PreLoader from "../../core/common/preLoader";
import CustomToast from '../../core/common/customToast';


interface Props {
  show: boolean;
  onDecline: () => void;
  onAccept?: () => void;
}

const TermsAndConditions = ({ show, onDecline, onAccept }: Props) => {
  const { isLoading, error, callFetch } = useFetch();
  const [termsDetails, setTermsDetails] = useState<any>(null);
  const [termsData, setTermsData] = useState<any>(null);
  const [toastSettings, setToastSettings] = useState<{
        show: boolean;
        message: string;
        heading: string;
        type: "ERROR" | "SUCCESS" | "INFO";
    }>({
        show: false,
        message: "Something went wrong please try again later",
        heading: "Oops! Something went wrong",
        type: "ERROR",
    });


  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  const fetchTermsAndConditions = () => {
    callFetch(API.TERMS_AND_CONDITIONS, "GET", getAPIHeaders(), null, null)
        .then((data) => {
          setTermsDetails(data);
          setTermsData(JSON.parse(data?.content));
        })
        .catch((error) => {
          console.error("Error fetching terms data:", error);
        });
  };

  const registerConsent = () => {
        const consentData = {
            documentId: termsDetails?.id,
        }

        callFetch(API.REGISTER_CONSENT, "POST", getAPIHeaders(), null, consentData).then(() => {
            if (onAccept) {
                onAccept();
            }
        }).catch(err => {
                setToastSettings({
                    show: true,
                    message: error?.response?.data || "Failed to register consent",
                    heading: "Error",
                    type: "ERROR",
                });
        });
    }
  const renderContent = (contentItems: any) => {
    if (!contentItems) return null;

    return contentItems.map((item: any, index: any) => {
      switch (item.type) {
        case "h1":
          return (
            <h1
              key={index}
              className="terms-heading my-3"
              dangerouslySetInnerHTML={{ __html: item.text || "" }}
            />
          );
        case "h2":
          return (
            <div key={index} className="terms-section mb-3">
              <h3
                className="terms-subheading my-3"
                dangerouslySetInnerHTML={{ __html: item.text || "" }}
              />
              {item.content && renderContent(item.content)}
            </div>
          );
        case "paragraph":
          return (
            <div key={index} className="terms-paragraph-wrapper mb-3">
              <p
                className="mb-2"
                dangerouslySetInnerHTML={{ __html: item.text || "" }}
              />
              {item.content && renderContent(item.content)}
            </div>
          );
        case "ul":
          return (
            <ul key={index} className="terms-list mb-3">
              {item.items &&
                item.items.map((listItem: any, listIndex: any) => (
                  <li key={listIndex} className="terms-list-item mb-2">
                    <span
                      dangerouslySetInnerHTML={{ __html: listItem.text || "" }}
                    />
                    {listItem.content && renderContent(listItem.content)}
                  </li>
                ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };
  return (
    <div>
      <PreLoader showLoader={isLoading} />
      <CustomToast
        show={toastSettings?.show}
        message={toastSettings?.message}
        heading={toastSettings?.heading}
        type={toastSettings?.type}
        onClose={() => {
            setToastSettings((prev) => ({
                ...prev,
                show: false,
            }));
        }}
      />
      <CustomModal
        backdrop="static"
        size="xl"
        show={show}
        onClose={onDecline}
        title={"Terms and Conditions"}
        bodyContent={
          <div className="overflow-auto" style={{ maxHeight: '60vh' }}>
            <>{renderContent(termsData?.content)}</>
          </div>        
        }
        footerContent={
          <div className={"w-100 flex-column d-flex"}>
            <div className="align-self-end">
             <button
                className="btn btn-success me-2"
                onClick={registerConsent}
              >
                Accept
              </button>
              <button
                className="btn btn-danger me-2"
                onClick={onDecline}
              >
                Decline
              </button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default TermsAndConditions;